/**
 * Use encodeURIComponent + btoa to handle Unicode characters safely
 */
export const safeBase64Encode = (input: string): string =>
  btoa(
    encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, (_match, p1) =>
      String.fromCharCode(parseInt(p1, 16)),
    ),
  )
